// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XGmu","type":"styles_type__3MDjX","choices":"styles_choices__200Yk"};